import * as yup from 'yup';

export const selectProductStepSchema = yup
  .object({
    localInstrumentName: yup.string().label('Transfer type').required(),
    corridorId: yup.string().label('Corridor').required(),
    productSchemaId: yup.string().label('Data required').required()
  })
  .required();
